import { NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import './AppObjectHistoryTab.css'

export default function AppObjectHistoryTab({ activeTab, setActiveTab }) {
  return (
    <NavItem>
      <NavLink className={classnames({ active: activeTab === 'history'})} onClick={() => {setActiveTab('history')}}>History</NavLink>
    </NavItem>
  )
}
